export const FETCH_WAYPOINTS_REQUEST = 'FETCH_WAYPOINTS_REQUEST'
export const FETCH_WAYPOINTS_FULFILLED = 'FETCH_WAYPOINTS_FULFILLED'
export const FETCH_WAYPOINTS_ERRED = 'FETCH_WAYPOINTS_ERRED'
export const SET_SELECTED_WAYPOINT = 'SET_SELECTED_WAYPOINT'
export const SET_SELECTED_WAYPOINT_FULFILLED = 'SET_SELECTED_WAYPOINT_FULFILLED'
export const SET_HOVERED_WAYPOINT = 'SET_HOVERED_WAYPOINT'
export const SAVE_WAYPOINT = 'SAVE_WAYPOINT'
export const SAVE_WAYPOINT_FULFILLED = 'SAVE_WAYPOINT_FULFILLED'
export const SAVE_WAYPOINT_ERRED = 'SAVE_WAYPOINT_ERRED'
